import i18n, { AVAILABLE_LANGS } from '../../i18n';
import { log } from '../utils/logging.util';
import { paramsToObject } from '../utils/common.utils';
import { stores } from '../../stores';

class I18nService {
  init() {
    const params = paramsToObject(new URLSearchParams(window.location.search));
    const { locale, lang, language, lng } = params;
    const langFromQuery = (language || lang || locale || lng || '')
      .toLowerCase()
      .slice(0, 2);

    i18n.on('initialized', () => {
      stores.AppStore.setIsI18nextInitiated(true);
      if (AVAILABLE_LANGS.includes(langFromQuery)) {
        i18n.changeLanguage(langFromQuery);
      }

      if (!AVAILABLE_LANGS.includes(i18n.language)) {
        log(
          `[i18n] ${i18n.language} locale is not supported, defaulting to [${i18n.options.fallbackLng[0]}] locale`,
          'warn'
        );
        i18n.changeLanguage(i18n.options.fallbackLng[0]);
      }
    });
  }
}

export const i18nService = new I18nService();
